import { render, staticRenderFns } from "./LnurlItem.vue?vue&type=template&id=4e3ffdb8&scoped=true&"
import script from "./LnurlItem.vue?vue&type=script&lang=js&"
export * from "./LnurlItem.vue?vue&type=script&lang=js&"
import style0 from "./LnurlItem.vue?vue&type=style&index=0&id=4e3ffdb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3ffdb8",
  null
  
)

export default component.exports